import { render, staticRenderFns } from "./RadialBar.vue?vue&type=template&id=f3901012&scoped=true"
import script from "./RadialBar.vue?vue&type=script&lang=ts"
export * from "./RadialBar.vue?vue&type=script&lang=ts"
import style0 from "./RadialBar.vue?vue&type=style&index=0&id=f3901012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3901012",
  null
  
)

export default component.exports